import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterLink } from '@angular/router';
import { BooleanInput } from '@angular/cdk/coercion';
import { Store } from '@ngrx/store';
import { NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';

import * as authActions from '../../../../../../shared/src/lib/store/actions/auth.actions';
import { AuthenticationService } from '../../../../../../shared/src/lib/service/authentification.service';
import { User } from '../../../../../../shared/src/lib/model/user.model';

@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        MatButtonModule, 
        MatMenuModule, 
        NgIf, 
        MatIconModule, 
        MatDividerModule, 
        RouterLink, 
        TranslateModule
    ],
    exportAs: 'user',
})
export class UserComponent implements OnInit, OnDestroy {
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() showAvatar: boolean = true;
    user: User;

    private destroyRef = inject(DestroyRef);

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _authService: AuthenticationService,
        private store: Store,
        private router: Router,
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.store
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((store: any) => {
                if (store.user?.me?.user) {
                    this.user = store.user.me.user;
                    this._changeDetectorRef.markForCheck();
                }
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Cleanup handled by takeUntilDestroyed
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Update the user status
     *
     * @param status
     */
    updateUserStatus(status: string): void {
        // Return if user is not available
        if (!this.user) {
            return;
        }

        // Update logic if needed
    }

    /**
     * Sign out
     */
    signOut(): void {
        this._authService.logout();
        this.store.dispatch(authActions.logout());
        this.router.navigateByUrl('login');
    }
}
